<template>
  <div>
    <PageHeader :schema="$schemas.customer" />
    <PageContent>
      <DynamicFormPage :schema="$schemas.customer" :service="$api.customers" />
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicFormPage from '@/components/dynamics/DynamicFormPage';

export default {
  name: 'CreateCustomer',
  components: { PageHeader, PageContent, DynamicFormPage },
  data() {
    return {};
  },
};
</script>
